import React from 'react';

import background from 'assets/img/bg-auth-full.jpg';
import logoBlue from 'assets/img/logo-blue.png';

const AuthLayout = ({ children }) => (
  <div className="container-fluid auth-container">
    <div className="row auth-wrapper">
      <div className="col-sm-6 col-lg-6 px-0 d-none d-sm-block">
        <div className="auth-side-background" style={{ backgroundImage: `url(${background})` }} />
        <img src={logoBlue} alt="SAAF" className="auth-side-logo" />
      </div>
      <div className="col-sm-6 col-lg-6 bg-white">
        <div className="row d-sm-none">
          <div className="col-12 text-center mt-3">
            <img src={logoBlue} alt="SAAF" className="auth-logo" />
          </div>
        </div>
        <div
          className="auth-side-background d-sm-none"
          style={{ backgroundImage: `url(${background})` }}
        />
        {children}
      </div>
    </div>
  </div>
);

export default AuthLayout;



// WEBPACK FOOTER //
// src/modules/auth/components/AuthLayout.js